import React from 'react';
import styled,{css} from 'styled-components';
// import FooterApp from './Components/FooterApp';

import DivBodyInicio1 from './DivBodyInicio1.js';
import DivBodyInicio2 from './DivBodyInicio2.js';
import FooterInicio from '../FooterInicio/FooterInicio';

const BodyInicio = ({ viewInicio, viewParcelas }) => {
    return(
        <BodyInicioCSS 
          viewInicio = { viewInicio }
          viewParcelas = { viewParcelas }
        >
        <DivBodyInicio1></DivBodyInicio1>
        <DivBodyInicio2></DivBodyInicio2>
        <FooterInicio></FooterInicio>
      </BodyInicioCSS>
    )
}
export default BodyInicio;

const BodyInicioCSS = styled.div`
  background-color: transparent;
  position:relative;
  height: 200%;
  z-index: 2;
  display: none;
  top:12%;
  ${props => props.viewInicio === false && css`
    display: none;
  `}
  
  ${props => props.viewInicio === true && css`
    display:block;
  `}
`;

